<main id="main-content">
    <div class="container">
        <div class="row mb-3">
            <div class="col section-title-full">
                <h1>
                    <span i18n>Nuevo vehículo</span>
                </h1>
            </div>
        </div>
    </div>

    <app-vehicle [applicantId]="applicantId" (goBackEvent)="goBack()"
        (goNewEvent)="goToNewException($event)"></app-vehicle>
</main>